import { FC, useEffect, useMemo } from 'react'
import { Box, Input, Select } from '@chakra-ui/react'
import { UseFormRegister } from 'react-hook-form'

import { FormItem } from 'components'
import { ROLE_INITIAL_FILTER_FIELDS } from 'Attendances/constants/pages/roles'
import { RoleFieldsName, RoleFilter } from 'Attendances/types'
import { CATEGORIES_OPTIONS, STATUS_OPTIONS } from 'constants/variables'
import { focusElementById } from 'utils/events'

type Props = {
  isOpen?: boolean
  hasPrefix?: boolean
  register: UseFormRegister<RoleFilter>
  onlyFields?: RoleFieldsName[]
}

const RoleFilterForm: FC<Props> = ({ hasPrefix = false, isOpen = false, register, onlyFields }) => {
  const roleFilterFields = useMemo(() => {
    return onlyFields || ROLE_INITIAL_FILTER_FIELDS
  }, [])

  function setPrefix(key?: string): any {
    if (hasPrefix) return `role_${key}`
    return key
  }

  useEffect(() => {
    focusElementById('name')
  }, [isOpen])

  return (
    <Box>
      {roleFilterFields.includes('id') && (
        <FormItem label="ID" htmlFor="id">
          <Input id="id" {...register(setPrefix('id'))} />
        </FormItem>
      )}
      {roleFilterFields.includes('name') && (
        <FormItem label="Nome" htmlFor="name">
          <Input id="name" {...register(setPrefix('name'))} />
        </FormItem>
      )}
      {roleFilterFields.includes('category') && (
        <FormItem label="Categoria" htmlFor="category">
          <Select id="category" {...register('category')}>
            <option value="">Todas</option>
            {CATEGORIES_OPTIONS.map(({ label, value }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              )
            })}
          </Select>
        </FormItem>
      )}
      {roleFilterFields.includes('status') && (
        <FormItem label="Status" htmlFor="status">
          <Select id="status" {...register(setPrefix('status'))}>
            {STATUS_OPTIONS.map(({ label, value }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              )
            })}
          </Select>
        </FormItem>
      )}
    </Box>
  )
}

export default RoleFilterForm
